
/// <amd-module name="Environments/Client/PageContextHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPageService, IPageData } from "VSS/Platform/Page";
import { IProjectData, getTFSPageData } from "Tfs/Platform/Page";

export class PageContextHelper {
    public static getAccountUri(pageContext: IVssPageContext): string | undefined {
        const vssPageService = pageContext.getService<IVssPageService>("IVssPageService");
        const vssPageData = vssPageService.getData();

        if (vssPageData) {
            let url: string = window.location.origin + vssPageData.hostPath;
            const isOnPremise: boolean = !this.isHostedType(pageContext);
            if (isOnPremise) {
                let collectionName: string = PageContextHelper.getCollectionName(pageContext);
                url = url.replace(`/${collectionName}/`, "")
            }
            return url;
        }

        return undefined;
    }

    public static getProject(pageContext: IVssPageContext): IProjectData | undefined {
        const tfsPageData = getTFSPageData(pageContext);

        if (tfsPageData && tfsPageData.project) {
            return tfsPageData.project;
        }

        return undefined;
    }

    public static getCurrentUserId(pageContext: IVssPageContext): string | null {
        const pageService = pageContext.getService<IVssPageService>("IVssPageService");
        const pageData: IPageData | undefined = pageService.getData();  

        return pageData ? pageData.user.id : null;
    }

    public static getProjectName(pageContext: IVssPageContext): string | undefined {
        const tfsPageData = getTFSPageData(pageContext);
        if (tfsPageData && tfsPageData.project) {
            return tfsPageData.project.name;
        }
    }

    public static getProjectId(pageContext: IVssPageContext): string | undefined {
        const tfsPageData = getTFSPageData(pageContext);
        if (tfsPageData && tfsPageData.project) {
            return tfsPageData.project.id;
        }
    }

    public static isHostedType(pageContext: IVssPageContext): boolean {
        const vssPageService = pageContext.getService<IVssPageService>("IVssPageService");
        const vssPageData = vssPageService.getData();
        
        return (!!vssPageData) ? vssPageData.isHosted : false;
    }

    public static isSSLEnabled(pageContext: IVssPageContext): boolean {
        const vssPageService = pageContext.getService<IVssPageService>("IVssPageService");
        const vssPageData = vssPageService.getData();
        
        return (!!vssPageData) ? vssPageData.isSslOnly : false;
    }

    public static getCollectionName(pageContext: IVssPageContext): string {    
        const vssPageService = pageContext.getService<IVssPageService>("IVssPageService");
        const vssPageData = vssPageService.getData();
        
        return (!!vssPageData) ? vssPageData.hostName : "";
    }
}